export function ucfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function isValidHttpUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}
